(function () {
  if (window.__riSystemAddons) return;
  window.__riSystemAddons = true;

  var qtyById = {};
  var cartItems = [];
  var phone = window.matchMedia("(max-width: 749px)");
  var bundleBusy = false;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function variantsOf(row) {
    var node = row.querySelector("[data-ri-addon-data]");
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function selectedVariant(row) {
    var select = row.querySelector("[data-ri-addon-select]");
    var id = select ? select.value : row.getAttribute("data-ri-addon-selected");
    var variants = variantsOf(row);
    var match = variants.find(function (item) {
      return String(item.id) === String(id);
    });
    return match || variants[0] || null;
  }

  function moneyText(cents) {
    return "$" + (Math.round(Number(cents) || 0) / 100).toFixed(2);
  }

  function moneyHtml(cents) {
    if (window.RIMoney && window.RIMoney.formatCents) return window.RIMoney.formatCents(cents, "$");
    return moneyText(cents);
  }

  function cartUrl() {
    var base = (window.routes && window.routes.cart_url) || "/cart";
    return base + ".js";
  }

  function titleOf(row) {
    var titleEl = row.querySelector("[data-ri-addon-title]");
    return titleEl ? titleEl.textContent.trim() : "this add-on";
  }

  function variantName(row, variant) {
    if (variant && variant.title && variant.title !== "Default Title") return variant.title;
    return titleOf(row);
  }

  function maxOf(variant) {
    return variant && variant.max != null ? Number(variant.max) : 99;
  }

  function stockText(variant) {
    var max = maxOf(variant);
    if (max > 3) return "";
    var left = max - (qtyById[String(variant.id)] || 0);
    if (left <= 0) return "All in your cart";
    return "Only " + left + " left";
  }

  /* Same faces as ri-card-atc.js, painted from the cart this file already holds. */
  function paintSwitch(sw, id, max) {
    if (!sw) return;
    var qty = qtyById[String(id)] || 0;
    var add = sw.querySelector("[data-ri-atc-variant]");
    var face = sw.querySelector(".ri-card-atc__qtyface");
    var qtyEl = sw.querySelector("[data-ri-atc-qty]");
    var trash = sw.querySelector("[data-ri-atc-remove]");
    var plus = sw.querySelector("[data-ri-atc-plus]");
    sw.classList.remove("is-leaving");
    sw.classList.toggle("is-in-cart", qty > 0);
    if (qtyEl) qtyEl.textContent = qty > 0 ? qty + " in cart" : "";
    if (add) {
      if (qty > 0) {
        add.setAttribute("aria-hidden", "true");
        add.tabIndex = -1;
      } else {
        add.removeAttribute("aria-hidden");
        add.removeAttribute("tabindex");
      }
    }
    if (face) {
      if (qty > 0) {
        face.removeAttribute("aria-hidden");
        face.removeAttribute("inert");
      } else {
        face.setAttribute("aria-hidden", "true");
        face.setAttribute("inert", "");
      }
    }
    if (trash) {
      var many = qty >= 2;
      trash.classList.toggle("is-minus", many);
      trash.setAttribute("aria-label", many ? "Remove one" : trash.getAttribute("data-ri-remove-label") || "Remove");
    }
    if (plus) {
      var ready = qty > 0 && max > qty;
      plus.classList.toggle("is-ready", ready);
      plus.disabled = !ready;
      if (ready) {
        plus.removeAttribute("aria-hidden");
        plus.removeAttribute("tabindex");
      } else {
        plus.setAttribute("aria-hidden", "true");
        plus.tabIndex = -1;
      }
    }
  }

  function pointSwitch(sw, id, max, removeLabel) {
    sw.querySelectorAll("[data-ri-atc-variant], [data-ri-atc-remove], [data-ri-atc-plus]").forEach(function (el) {
      if (el.hasAttribute("data-ri-atc-variant")) el.setAttribute("data-ri-atc-variant", id);
      if (el.hasAttribute("data-ri-atc-remove")) el.setAttribute("data-ri-atc-remove", id);
      if (el.hasAttribute("data-ri-atc-plus")) el.setAttribute("data-ri-atc-plus", id);
      if (el.hasAttribute("data-ri-atc-max")) el.setAttribute("data-ri-atc-max", max);
    });
    var trash = sw.querySelector("[data-ri-atc-remove]");
    if (trash) {
      trash.setAttribute("aria-label", removeLabel);
      trash.setAttribute("data-ri-remove-label", removeLabel);
    }
  }

  /* repoint: the shown color changed, so the button face swaps at once instead of waiting for ri-card-atc.js. */
  function paintRow(row, repoint) {
    var variant = selectedVariant(row);
    if (!variant) return;
    var id = String(variant.id);
    var max = String(maxOf(variant));
    var raised = row.hasAttribute("data-ri-addon-raised");
    row.setAttribute("data-ri-addon-selected", id);
    var price = row.querySelector("[data-ri-addon-price]");
    if (price) {
      if (raised) price.innerHTML = "+" + moneyHtml(variant.price);
      else price.textContent = "+" + moneyText(variant.price);
    }
    var photo = row.querySelector("[data-ri-addon-photo]");
    if (photo && variant.image && photo.getAttribute("src") !== variant.image) photo.src = variant.image;
    var input = row.querySelector('input[name="id"]');
    if (input) input.value = id;
    var sw = row.querySelector(".ri-card-atc__switch");
    if (!sw) return;
    pointSwitch(sw, id, max, "Remove " + variantName(row, variant));
    if (!raised) return;
    if (repoint) paintSwitch(sw, id, Number(max));
    var choice = row.querySelector("[data-ri-addon-choice]");
    if (choice) choice.textContent = variant.title;
    var stock = row.querySelector("[data-ri-addon-stock]");
    if (stock) {
      var text = stockText(variant);
      stock.textContent = text;
      stock.hidden = !text;
    }
  }

  /* Wide screen: each held color gets its own small stepper. */
  function paintHeld(row) {
    var list = row.querySelector("[data-ri-addon-held]");
    if (!list) return;
    var variants = variantsOf(row);
    if (variants.length < 2) {
      list.hidden = true;
      list.replaceChildren();
      return;
    }
    var held = variants.filter(function (variant) {
      return (qtyById[String(variant.id)] || 0) > 0;
    });
    if (!held.length) {
      list.hidden = true;
      list.replaceChildren();
      return;
    }
    var icon = row.querySelector(".ri-card-atc__switch .svg-wrapper");
    list.hidden = false;
    list.replaceChildren();
    held.forEach(function (variant) {
      var id = String(variant.id);
      var qty = qtyById[id] || 0;
      var max = maxOf(variant);
      var item = document.createElement("span");
      item.className = "ri-system-addons__held-item";
      var remove = document.createElement("button");
      remove.type = "button";
      remove.className = "ri-card-atc__iconbtn ri-system-addons__step" + (qty > 1 ? " is-minus" : "");
      remove.setAttribute("data-ri-atc-remove", id);
      remove.setAttribute("aria-label", "Remove " + variantName(row, variant));
      if (icon) remove.appendChild(icon.cloneNode(true));
      var name = document.createElement("span");
      name.className = "ri-system-addons__held-name";
      name.textContent = variantName(row, variant) + " \u00d7" + qty;
      var plus = document.createElement("button");
      plus.type = "button";
      plus.className = "ri-card-atc__iconbtn ri-card-atc__plus ri-system-addons__step" + (qty < max ? " is-ready" : "");
      plus.setAttribute("data-ri-atc-plus", id);
      plus.setAttribute("data-ri-atc-max", String(max));
      plus.setAttribute("aria-label", "Add one more");
      if (qty >= max) plus.disabled = true;
      var mark = document.createElement("span");
      mark.setAttribute("aria-hidden", "true");
      mark.textContent = "+";
      plus.appendChild(mark);
      item.appendChild(remove);
      item.appendChild(name);
      item.appendChild(plus);
      list.appendChild(item);
    });
  }

  /* Phone: one plain line that names every color in the cart. Tapping it opens the color sheet. */
  function paintHeldLine(row) {
    var line = row.querySelector("[data-ri-addon-held-line]");
    if (!line) return;
    var held = variantsOf(row).filter(function (variant) {
      return (qtyById[String(variant.id)] || 0) > 0;
    });
    if (!held.length) {
      line.hidden = true;
      line.textContent = "";
      return;
    }
    line.hidden = false;
    line.textContent =
      "In cart: " +
      held
        .map(function (variant) {
          return variantName(row, variant) + " \u00d7" + (qtyById[String(variant.id)] || 0);
        })
        .join(", ");
  }

  function systemQtyFor(wrap) {
    var systemId = wrap && wrap.getAttribute("data-ri-addon-system");
    if (!systemId) return 0;
    var total = 0;
    cartItems.forEach(function (item) {
      if (String(item.product_id) === systemId) total += item.quantity || 0;
    });
    return total;
  }

  function systemPrices(list) {
    var node = list.querySelector("[data-ri-addon-system-prices]");
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  /* The condition on this system, not a related product's form and not a copy already in the cart. */
  function selectedSystem(list) {
    var prices = systemPrices(list);
    var byId = {};
    prices.forEach(function (variant) {
      byId[String(variant.id)] = Number(variant.price) || 0;
    });
    var id = list.getAttribute("data-ri-addon-system-selected");
    var product = list.closest(".product") || list.closest("product-info") || document;
    var info = product.querySelector(".product__info-container") || product;
    info.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      if (form.closest(".ri-system-addons, .ri-addon-m")) return;
      var input = form.querySelector('input[name="id"]');
      if (input && byId[String(input.value)] != null) id = input.value;
    });
    return { id: id, price: byId[String(id)] || 0 };
  }

  function paintBundle() {
    document.querySelectorAll("[data-ri-addon-list]").forEach(function (list) {
      var box = list.querySelector("[data-ri-addon-bundle]");
      var text = list.querySelector("[data-ri-addon-bundle-text]");
      var action = list.querySelector("[data-ri-addon-bundle-action]");
      if (!box || !text || !action) return;
      var addonIds = {};
      list.querySelectorAll("[data-ri-addon-product]").forEach(function (el) {
        addonIds[el.getAttribute("data-ri-addon-product")] = true;
      });
      var addonQty = 0;
      var addonTotal = 0;
      cartItems.forEach(function (item) {
        if (!addonIds[String(item.product_id)]) return;
        addonQty += item.quantity || 0;
        addonTotal += item.final_line_price != null ? item.final_line_price : item.line_price || 0;
      });
      if (!addonQty) {
        box.hidden = true;
        text.textContent = "";
        return;
      }
      var picked = selectedSystem(list);
      var count = addonQty + 1;
      var total = addonTotal + picked.price;
      var inCart = systemQtyFor(list) > 0;
      box.hidden = false;
      text.innerHTML = "Your bundle: " + count + (count === 1 ? " item" : " items") + " \u00b7 " + moneyHtml(total);
      action.textContent = inCart ? "Go to cart" : "Add to cart";
      action.setAttribute("data-ri-addon-bundle-mode", inCart ? "cart" : "add");
      if (!bundleBusy) action.disabled = false;
    });
  }

  function bundleError(list, message) {
    var error = list && list.querySelector("[data-ri-addon-bundle-error]");
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    window.clearTimeout(error.__riTimer);
    error.__riTimer = window.setTimeout(function () {
      error.hidden = true;
    }, 4000);
  }

  function addSystem(list) {
    if (bundleBusy || !list) return;
    var picked = selectedSystem(list);
    if (!picked.id) return;
    var action = list.querySelector("[data-ri-addon-bundle-action]");
    bundleBusy = true;
    if (action) action.disabled = true;
    var url = ((window.routes && window.routes.cart_add_url) || "/cart/add") + ".js";
    fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(picked.id), quantity: 1 }] }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data && data.status)) throw new Error((data && (data.description || data.message)) || "add");
        });
      })
      .then(function () {
        return fetch(cartUrl(), { credentials: "same-origin", headers: { Accept: "application/json" } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        bundleBusy = false;
        publishCart(cart, "ri-system-addon");
        pulseCart();
      })
      .catch(function (error) {
        bundleBusy = false;
        if (action) action.disabled = false;
        var message = error && error.message && error.message !== "add" ? error.message : "Not added. Try again.";
        bundleError(list, message);
        loadHeld();
      });
  }

  /* The gray row eases taller or shorter when an add-on line grows. First paint stays put. */
  function beginSlide(row) {
    if (!row || !row.__riReady || reduceMotion.matches) return;
    row.__riFrom = row.getBoundingClientRect().height;
  }

  function endSlide(row) {
    if (!row) return;
    if (!row.__riReady) {
      row.__riReady = true;
      return;
    }
    var from = row.__riFrom;
    row.__riFrom = null;
    if (from == null || reduceMotion.matches) return;
    if (row.__riSlideEnd) row.removeEventListener("transitionend", row.__riSlideEnd);
    row.style.transition = "none";
    row.style.overflow = "hidden";
    row.style.boxSizing = "border-box";
    row.style.height = "auto";
    var to = row.getBoundingClientRect().height;
    if (Math.abs(to - from) < 1) {
      row.style.height = "";
      row.style.overflow = "";
      row.style.transition = "";
      return;
    }
    row.style.height = from + "px";
    void row.offsetHeight;
    row.style.transition = "height 0.32s cubic-bezier(0.22, 1, 0.36, 1)";
    row.style.height = to + "px";
    var finish = function (event) {
      if (event && event.propertyName && event.propertyName !== "height") return;
      row.style.height = "";
      row.style.overflow = "";
      row.style.transition = "";
      row.removeEventListener("transitionend", finish);
      if (row.__riSlideEnd === finish) row.__riSlideEnd = null;
    };
    row.__riSlideEnd = finish;
    row.addEventListener("transitionend", finish);
    window.setTimeout(function () {
      if (row.__riSlideEnd === finish) finish();
    }, 450);
  }

  function paintRows() {
    document.querySelectorAll("[data-ri-addon-row]").forEach(function (row) {
      beginSlide(row);
      paintRow(row);
      paintHeld(row);
      paintHeldLine(row);
      endSlide(row);
    });
    paintBundle();
    paintSheet();
  }

  function rememberCart(cart) {
    qtyById = {};
    cartItems = (cart && cart.items) || [];
    cartItems.forEach(function (item) {
      var id = String(item.variant_id != null ? item.variant_id : item.id);
      qtyById[id] = (qtyById[id] || 0) + (item.quantity || 0);
    });
    paintRows();
  }

  function loadHeld() {
    return fetch(cartUrl(), { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        rememberCart(cart);
        return cart;
      })
      .catch(function () {
        paintRows();
      });
  }

  function publishCart(cart, source) {
    rememberCart(cart);
    if (typeof publish !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cart });
  }

  function pulseCart() {
    if (phone.matches && typeof window.RICartPulse === "function") window.RICartPulse();
  }

  /* ---------- Color sheet (phone) ---------- */

  var sheet = null;
  var sheetRow = null;
  var sheetPushed = false;
  var sheetSkipPop = false;
  var sheetHideTimer = 0;
  var lastFocus = null;
  var drag = null;

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function buildSheet() {
    if (sheet) return sheet;
    sheet = el("div", "ri-addon-m-sheet");
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="ri-addon-m-sheet__scrim" data-ri-sheet-close></div>' +
      '<div class="ri-addon-m-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="RiAddonSheetTitle" tabindex="-1">' +
      '<div class="ri-addon-m-sheet__head" data-ri-sheet-drag>' +
      '<span class="ri-addon-m-sheet__handle" aria-hidden="true"></span>' +
      '<div class="ri-addon-m-sheet__headrow"><div>' +
      '<p class="ri-addon-m-sheet__kicker" data-ri-sheet-kicker></p>' +
      '<h2 class="ri-addon-m-sheet__title" id="RiAddonSheetTitle" data-ri-sheet-title></h2>' +
      "</div>" +
      '<button type="button" class="ri-addon-m-sheet__close" data-ri-sheet-close aria-label="Close">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2.5" fill="none"/></svg>' +
      "</button></div></div>" +
      '<div class="ri-addon-m-sheet__body"><div class="ri-addon-m-sheet__grid" role="radiogroup" aria-labelledby="RiAddonSheetTitle" data-ri-sheet-grid></div></div>' +
      '<div class="ri-addon-m-sheet__foot">' +
      '<p class="ri-addon-m__error ri-addon-m-sheet__error" data-ri-sheet-error role="alert" hidden></p>' +
      '<div class="ri-card-atc ri-card-atc--sheet"><div class="ri-card-atc__switch ri-card-atc__switch--wide">' +
      '<div class="ri-pdp-atc__face"><button type="button" class="ri-card-atc__add" data-ri-sheet-add data-ri-atc-variant="" data-ri-atc-max="99">' +
      '<span class="ri-card-atc__label" data-ri-sheet-label>Add</span></button></div>' +
      '<div class="ri-card-atc__qtyface" aria-hidden="true" inert>' +
      '<button type="button" class="ri-card-atc__iconbtn" data-ri-atc-remove="" aria-label="Remove" data-ri-sheet-trash></button>' +
      '<span class="ri-card-atc__qty" data-ri-atc-qty></span>' +
      '<button type="button" class="ri-card-atc__iconbtn ri-card-atc__plus" data-ri-atc-plus="" data-ri-atc-max="99" aria-label="Add one more" tabindex="-1"><span aria-hidden="true">+</span></button>' +
      "</div></div></div></div></div>";
    document.body.appendChild(sheet);

    sheet.addEventListener("click", function (event) {
      if (event.target.closest("[data-ri-sheet-close]")) {
        event.preventDefault();
        closeSheet(false);
        return;
      }
      var tile = event.target.closest("[data-ri-sheet-variant]");
      if (tile) {
        chooseVariant(tile.getAttribute("data-ri-sheet-variant"));
        return;
      }
      if (event.target.closest("[data-ri-sheet-add]")) {
        event.preventDefault();
        sheetAdd();
      }
    });

    sheet.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeSheet(false);
        return;
      }
      if (event.key === "ArrowRight" || event.key === "ArrowLeft" || event.key === "ArrowDown" || event.key === "ArrowUp") {
        var tile = event.target.closest("[data-ri-sheet-variant]");
        if (!tile) return;
        var tiles = Array.prototype.slice.call(sheet.querySelectorAll("[data-ri-sheet-variant]"));
        var step = event.key === "ArrowRight" || event.key === "ArrowDown" ? 1 : -1;
        var next = tiles[(tiles.indexOf(tile) + step + tiles.length) % tiles.length];
        if (!next) return;
        event.preventDefault();
        chooseVariant(next.getAttribute("data-ri-sheet-variant"));
        next.focus();
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = Array.prototype.filter.call(
        sheet.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'),
        function (node) {
          return node.offsetParent !== null && !node.closest("[inert]");
        }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var head = sheet.querySelector("[data-ri-sheet-drag]");
    head.addEventListener("pointerdown", function (event) {
      if (event.target.closest("button")) return;
      drag = { id: event.pointerId, y: event.clientY, t: Date.now(), dy: 0 };
      head.setPointerCapture && head.setPointerCapture(event.pointerId);
      sheet.classList.add("is-dragging");
    });
    head.addEventListener("pointermove", function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      drag.dy = Math.max(0, event.clientY - drag.y);
      sheet.style.setProperty("--ri-sheet-drag", drag.dy + "px");
    });
    var endDrag = function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var fast = drag.dy > 30 && drag.dy / Math.max(1, Date.now() - drag.t) > 0.5;
      var shut = drag.dy > 90 || fast;
      drag = null;
      sheet.classList.remove("is-dragging");
      if (shut) closeSheet(false);
      else sheet.style.removeProperty("--ri-sheet-drag");
    };
    head.addEventListener("pointerup", endDrag);
    head.addEventListener("pointercancel", endDrag);
    return sheet;
  }

  function preloadPhotos(row) {
    if (!row || row.__riPhotosLoaded) return;
    row.__riPhotosLoaded = true;
    variantsOf(row).forEach(function (variant) {
      if (!variant.image) return;
      var img = new Image();
      img.decoding = "async";
      img.src = variant.image;
    });
  }

  function renderTiles() {
    var grid = sheet.querySelector("[data-ri-sheet-grid]");
    var variants = variantsOf(sheetRow);
    var prices = {};
    variants.forEach(function (variant) {
      prices[variant.price] = true;
    });
    var mixed = Object.keys(prices).length > 1;
    grid.replaceChildren();
    variants.forEach(function (variant) {
      var tile = el("button", "ri-addon-m-sheet__tile");
      tile.type = "button";
      tile.setAttribute("role", "radio");
      tile.setAttribute("data-ri-sheet-variant", String(variant.id));
      var photo = el("span", "ri-addon-m-sheet__tile-photo");
      if (variant.image) {
        var img = document.createElement("img");
        img.src = variant.image;
        img.alt = "";
        img.width = 160;
        img.height = 160;
        img.decoding = "async";
        photo.appendChild(img);
      }
      tile.appendChild(photo);
      tile.appendChild(el("span", "ri-addon-m-sheet__tile-name", variantName(sheetRow, variant)));
      if (mixed) {
        var price = el("span", "ri-addon-m-sheet__tile-price");
        price.innerHTML = moneyHtml(variant.price);
        tile.appendChild(price);
      }
      var stock = el("span", "ri-addon-m-sheet__tile-stock");
      stock.setAttribute("data-ri-sheet-stock", "");
      tile.appendChild(stock);
      var count = el("span", "ri-addon-m-sheet__tile-count");
      count.setAttribute("data-ri-sheet-count", "");
      count.hidden = true;
      tile.appendChild(count);
      grid.appendChild(tile);
    });
  }

  function paintSheet(repoint) {
    if (!sheet || !sheetRow || sheet.hidden) return;
    var variant = selectedVariant(sheetRow);
    if (!variant) return;
    var id = String(variant.id);
    var max = maxOf(variant);
    sheet.querySelectorAll("[data-ri-sheet-variant]").forEach(function (tile) {
      var vid = tile.getAttribute("data-ri-sheet-variant");
      var on = vid === id;
      tile.setAttribute("aria-checked", on ? "true" : "false");
      tile.tabIndex = on ? 0 : -1;
      var tileVariant = variantsOf(sheetRow).find(function (item) {
        return String(item.id) === vid;
      });
      var qty = qtyById[vid] || 0;
      var count = tile.querySelector("[data-ri-sheet-count]");
      if (count) {
        count.hidden = qty < 1;
        count.textContent = qty > 0 ? String(qty) : "";
        count.setAttribute("aria-label", qty > 0 ? qty + " in cart" : "");
      }
      var stock = tile.querySelector("[data-ri-sheet-stock]");
      if (stock && tileVariant) {
        var text = stockText(tileVariant);
        stock.textContent = text;
        stock.hidden = !text;
      }
    });
    var sw = sheet.querySelector(".ri-card-atc__switch");
    var name = variantName(sheetRow, variant);
    pointSwitch(sw, id, String(max), "Remove " + name);
    var label = sheet.querySelector("[data-ri-sheet-label]");
    if (label) label.textContent = "Add " + name + " - " + moneyText(variant.price);
    var add = sheet.querySelector("[data-ri-sheet-add]");
    if (add) add.setAttribute("aria-label", "Add " + name + " to cart");
    if (repoint) paintSwitch(sw, id, max);
  }

  function chooseVariant(id) {
    if (!sheetRow) return;
    sheetRow.setAttribute("data-ri-addon-selected", String(id));
    paintRow(sheetRow, true);
    paintHeldLine(sheetRow);
    paintSheet(true);
  }

  function sheetAdd() {
    if (!sheetRow) return;
    var submit = sheetRow.querySelector('.ri-card-atc__add[type="submit"]');
    if (!submit || submit.disabled || submit.getAttribute("aria-disabled") === "true") return;
    var error = sheet.querySelector("[data-ri-sheet-error]");
    if (error) error.hidden = true;
    submit.click();
  }

  function openSheet(row) {
    if (!row || !phone.matches) return;
    buildSheet();
    window.clearTimeout(sheetHideTimer);
    sheetRow = row;
    lastFocus = document.activeElement;
    var trash = sheet.querySelector("[data-ri-sheet-trash]");
    var icon = row.querySelector(".ri-card-atc__iconbtn .svg-wrapper");
    if (trash && icon && !trash.firstChild) trash.appendChild(icon.cloneNode(true));
    var noun = row.getAttribute("data-ri-addon-noun");
    sheet.querySelector("[data-ri-sheet-kicker]").textContent = noun === "colors" ? "Choose a color" : "Choose an option";
    sheet.querySelector("[data-ri-sheet-title]").textContent = titleOf(row);
    var error = sheet.querySelector("[data-ri-sheet-error]");
    if (error) error.hidden = true;
    renderTiles();
    sheet.style.removeProperty("--ri-sheet-drag");
    var wasOpen = sheet.classList.contains("is-open");
    sheet.hidden = false;
    paintSheet(true);
    if (wasOpen) return;
    /* Push before the lock so the saved scroll spot is the real one. */
    try {
      history.pushState({ riAddonSheet: true }, "");
      sheetPushed = true;
    } catch (e) {
      sheetPushed = false;
    }
    if (window.RIScrollLock) window.RIScrollLock.lock();
    document.documentElement.classList.add("ri-sheet-open");
    void sheet.offsetHeight;
    sheet.classList.add("is-open");
    var current = sheet.querySelector('[data-ri-sheet-variant][aria-checked="true"]');
    var target = current || sheet.querySelector(".ri-addon-m-sheet__panel");
    window.requestAnimationFrame(function () {
      if (target) target.focus({ preventScroll: true });
    });
  }

  function closeSheet(fromPop) {
    if (!sheet || !sheet.classList.contains("is-open")) return;
    sheet.classList.remove("is-open", "is-dragging");
    sheet.style.removeProperty("--ri-sheet-drag");
    document.documentElement.classList.remove("ri-sheet-open");
    if (window.RIScrollLock) window.RIScrollLock.unlock();
    if (sheetPushed && !fromPop) {
      sheetSkipPop = true;
      history.back();
    }
    sheetPushed = false;
    sheetHideTimer = window.setTimeout(function () {
      if (!sheet.classList.contains("is-open")) sheet.hidden = true;
    }, 260);
    if (lastFocus && document.contains(lastFocus) && typeof lastFocus.focus === "function") {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  window.addEventListener("popstate", function () {
    if (sheetSkipPop) {
      sheetSkipPop = false;
      return;
    }
    if (sheet && sheet.classList.contains("is-open")) {
      sheetPushed = false;
      closeSheet(true);
    }
  });

  window.addEventListener("pageshow", function (event) {
    if (!event.persisted || !sheet) return;
    sheet.classList.remove("is-open", "is-dragging");
    sheet.hidden = true;
    sheetPushed = false;
  });

  var onPhoneChange = function () {
    if (!phone.matches) closeSheet(false);
  };
  if (phone.addEventListener) phone.addEventListener("change", onPhoneChange);
  else if (phone.addListener) phone.addListener(onPhoneChange);

  document.addEventListener(
    "pointerdown",
    function (event) {
      var opener = event.target.closest(".ri-addon-m [data-ri-addon-open]");
      if (opener) preloadPhotos(opener.closest("[data-ri-addon-row]"));
    },
    { passive: true }
  );

  document.addEventListener("click", function (event) {
    var opener = event.target.closest(".ri-addon-m [data-ri-addon-open]");
    if (opener) {
      event.preventDefault();
      var row = opener.closest("[data-ri-addon-row]");
      preloadPhotos(row);
      openSheet(row);
      return;
    }
    var bundleAction = event.target.closest("[data-ri-addon-bundle-action]");
    if (!bundleAction) return;
    event.preventDefault();
    var bundleList = bundleAction.closest("[data-ri-addon-list]");
    if (!bundleList) return;
    if (bundleAction.getAttribute("data-ri-addon-bundle-mode") === "cart") {
      window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      return;
    }
    addSystem(bundleList);
  });

  /* ri-card-atc.js owns the plus. On a phone the header cart flashes for it too. */
  document.addEventListener(
    "click",
    function (event) {
      var plus = event.target.closest(".ri-addon-m [data-ri-atc-plus], .ri-addon-m-sheet [data-ri-atc-plus]");
      if (plus && plus.classList.contains("is-ready") && !plus.disabled) pulseCart();
    },
    true
  );

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-ri-addon-select]");
    if (!select || !select.closest(".ri-system-addons")) return;
    var row = select.closest("[data-ri-addon-row]");
    if (!row) return;
    paintRow(row);
    paintHeld(row);
    document.dispatchEvent(new CustomEvent("cart:updated"));
  });

  document.addEventListener("cart:updated", function () {
    loadHeld();
  });

  function showRowError(variantId, message) {
    var text = typeof message === "string" && message ? message : "Not added. Try again.";
    document.querySelectorAll(".ri-addon-m [data-ri-addon-row]").forEach(function (row) {
      if (row.getAttribute("data-ri-addon-selected") !== String(variantId)) return;
      var error = row.querySelector("[data-ri-addon-error]");
      if (!error) return;
      error.textContent = text;
      error.hidden = false;
      window.clearTimeout(error.__riTimer);
      error.__riTimer = window.setTimeout(function () {
        error.hidden = true;
      }, 5000);
    });
    if (sheet && sheetRow && sheetRow.getAttribute("data-ri-addon-selected") === String(variantId)) {
      var sheetError = sheet.querySelector("[data-ri-sheet-error]");
      if (sheetError) {
        sheetError.textContent = text;
        sheetError.hidden = false;
      }
    }
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      paintBundle();
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (cart && cart.items) {
        rememberCart(cart);
        return;
      }
      loadHeld();
    });
    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      if (!event || event.productVariantId == null) return;
      showRowError(event.productVariantId, event.message || event.errors);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", loadHeld);
  else loadHeld();
})();
